import ajax from 'axios';
import debounce from 'debounce';
import queryString from 'query-string';

ajax.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export default (() => {
  const baseUrl = '/experts';
  const tmpDoc = document.implementation.createHTMLDocument();
  const form = document.querySelector('[data-people-search]');
  const container = document.querySelector('#people-list');
  const urlParams = queryString.parse(location.search);
  const resultsCache = {};
  const {CancelToken} = ajax;
  let cancel;
  let query;

  if (!form || !container) {
    return;
  }

  // Initialize cache
  query = urlParams.q || '';
  resultsCache[query] = container.innerHTML;

  function handleInput(event) {
    event.preventDefault();

    // Make sure we aren't already loading this query
    if (form.q.value === query) {
      return;
    }
    query = form.q.value;

    doSearch();
  }

  function doSearch() {
    // Start loading animation
    container.classList.add('is-loading');

    // Is it cached?
    if (typeof resultsCache[query] !== 'undefined') {
      updateResults(resultsCache[query]);
      return;
    }

    // Cancel any outstanding requests
    if (cancel) {
      cancel();
      cancel = null;
    }

    // Send the request
    ajax
      .get(`${form.action}?q=${query}`, {
        cancelToken: new CancelToken(c => {
          // An executor function receives a cancel function as a parameter
          cancel = c;
        }),
      })
      .then(response => {
        if (response.data) {
          // Replace the list of people on the page
          tmpDoc.body.innerHTML = response.data;
          resultsCache[query] = tmpDoc.querySelector('#people-list').innerHTML;
          updateResults(resultsCache[query]);
        }
      })
      .catch(error => {
        if (!ajax.isCancel(error)) {
          container.innerHTML = error.message;
          container.classList.remove('is-loading');
        }
      });
  }

  function updateResults(data) {
    container.innerHTML = data;
    container.classList.remove('is-loading');
    window.sr && window.sr.sync();

    // Update the address bar
    if (window.history) {
      const newUrl = query !== '' ? `${baseUrl}?q=${query}` : baseUrl;
      window.history.replaceState({}, '', newUrl);
    }
  }

  if (form) {
    form.addEventListener('submit', handleInput);
    form.addEventListener('keyup', debounce(handleInput, 300));
  }
})();
